import React, { useState, useRef, useEffect, useContext } from "react";
import userIcon from "../images/User.png"
import menuIcon from "../images/Menu.png"
import shoppingBagIcon from "../images/ShoppingBag.png"
import { AuthContext } from './AuthProvider';
import { useNavigate } from 'react-router-dom';

const NavBar = () => {

  const { logout } = useContext(AuthContext);
  const [dropdownProfileVisible, setDropdownProfileVisible] = useState(false);
  const [dropdownMenuVisible, setDropdownMenuVisible] = useState(false);
  const navigate = useNavigate();

  const handleClickSignout = () => {
    logout();
    navigate('/login')
  }

  const handleClickMyBloom = () => {
    console.log("My Bloom clicked");
  }

  const handleClickBloomFit = () => {
    console.log("Bloom Fit clicked");
  }

  const handleClickBloomHome = () => {
    console.log("Bloom Home clicked");
    navigate('/jewellery');
  }

  const DropdownProfile = () => {
    return (
      <div className="dropdown-menu">
        <ul>
          <li onClick={handleClickSignout}><span>Sign Out</span></li>
        </ul>
      </div>
    );
  };

  const DropdownMenu = () => {
    return (
      <div className="dropdown-menu">
        <ul>
          <li onClick={handleClickBloomHome}><span>Bloom Home</span></li>
        </ul>
      </div>
    );
  };


  const handleMouseEnterProfile = () => {
    setDropdownProfileVisible(true);
  };

  const handleMouseLeaveProfile = () => {
    setDropdownProfileVisible(false);
  };

  const handleMouseEnterMenu = () => {
    setDropdownMenuVisible(true);
  };

  const handleMouseLeaveMenu = () => {
    setDropdownMenuVisible(false);
  };

  return (
    <div className="App-header">
      <div onMouseEnter={handleMouseEnterMenu} onMouseLeave={handleMouseLeaveMenu}>
        <div className="App-header-item" align="center">
          <img src={menuIcon} width="40px" height="40px" /></div>
        {dropdownMenuVisible && <DropdownMenu />}</div>
      <div className="App-header-item" align="center">Jewellery</div>
      <div className="App-header-item" align="center"><img src={shoppingBagIcon} width="40px" height="40px" /></div>
      <div onMouseEnter={handleMouseEnterProfile} onMouseLeave={handleMouseLeaveProfile}>
        <div className="App-header-item" align="center">
          <img src={userIcon} width="40px" height="40px" />
        </div>
        {dropdownProfileVisible && <DropdownProfile />}
      </div>
    </div>
  );
}

export default NavBar;


